import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { MessageVM } from '../../../models';
import { FormControl, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'account-message-write',
  templateUrl: 'messagewrite.component.html'
})
export class MessageWriteComponent extends BaseComponent implements OnInit {

  model: MessageVM = new MessageVM();
  sent: boolean = false;
  canReply: boolean = true;

  constructor(private fb: FormBuilder, private route: ActivatedRoute, private accService: AccountService, private router: Router) {
    super(route);
  }

  ngOnInit(): void {
    this.emitDisplayLoadingDialog(true);

    this.myForm = this.fb.group({
      'body': new FormControl('', Validators.required)
    });

    if (this.accService.messageOtherParty != null) {
      this.accService.canReply(this.accService.messageOtherParty.userId)
        .subscribe(
          r => {
            if (!r) {
              this.canReply = false;
            }
            else {
              this.model.to = this.accService.messageOtherParty;
            }
          }
          ,
          e => {
            console.log(e);
            this.router.navigateByUrl('/messages');
            this.emitDisplayLoadingDialog(false);
          },
          () => {
            this.emitDisplayLoadingDialog(false);
          }
        );
    }
    else {
      this.router.navigateByUrl('/messages');
    }

  }

  onSend() {
    this.markAsTouched(this.myForm);
    if (this.myForm.valid) {
      this.emitDisplayLoadingDialog(true);
      this.accService.sendMessage(this.model)
        .subscribe(
          result => {
            if (result) {
              this.sent = true;
            }
            else {
              this.showDialog("Message was not sent, please try again", true);
            }
          },
          error => this.showDialog("Message was not sent, please try again", true),
          () => this.emitDisplayLoadingDialog(false)
        );
    }
  }

  handleError(e: any) {
    console.log(e);
    if (e.status == 404) {
      this.router.navigateByUrl('/');
    }
  }

}
